<footer class="footer-minimal mt-5">
  <div class="container px-lg-5">
    <div class="row g-4 justify-content-between">

 <!-- Section 4: Contact us -->
      <div class="col-lg-3">
        <h6 class="minimal-title">{{'ReachOut' | translate}}</h6>
        <div class="minimal-contact">
          <p class="contact-item"><i class="bi bi-geo-alt me-2"></i> <span [innerHTML]="address"></span></p>
          <p class="contact-item"><i class="bi bi-telephone me-2"></i> {{ Telephone }}</p>
          <p class="contact-item">
            <a [href]="'mailto:' + EmailContact" class="contact-link">
              <i class="bi bi-envelope me-2"></i> {{ EmailContact }}
            </a>
          </p>
          <p class="contact-item mb-0">
            <a [href]="facebook" target="_blank" class="contact-link">
              <i class="bi bi-facebook me-2"></i> Facebook
            </a>
          </p>
          <div class="mt-4">
            <a [href]="libWebsite" target="_blank" class="minimal-btn">
              {{'VisitWebsite' | translate}} <i class="bi bi-arrow-up-right ms-1"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- Section 2: Explore -->
      <div class="col-sm-6 col-lg-2 mb-5 mb-lg-0">
        <h6 class="minimal-title">{{'Explore' | translate}}</h6>
        <nav class="minimal-nav">
          <a [routerLink]="'./search/alphabetic'">{{'AlphabeticallySearch' | translate}}</a>
          <a [routerLink]="'./search/advance'">{{'AdvancedSearch' | translate}}</a>
          <a [routerLink]="'news'">{{'News' | translate}}</a>
          <a [routerLink]="'aboutus'">{{'About us' | translate}}</a>
        </nav>
      </div>

      <!-- Section 3: Information -->
      <div class="col-sm-6 col-lg-2 mb-5 mb-lg-0">
        <h6 class="minimal-title">{{'Information' | translate}}</h6>
        <nav class="minimal-nav">
          <a [routerLink]="'regulation'">{{'Regulations' | translate}}</a>
          <a [routerLink]="'contactus'">{{'Contact us' | translate}}</a>
          <a [routerLink]="'/policy'">{{'Cookie Policy' | translate}}</a>
        </nav>
      </div>

     
    </div>

    <!-- Bottom Bar -->
    <div class="minimal-bottom mt-5 pt-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <p class="copyright-minimal mb-0">©2026 IICE — All Rights Reserved</p>
        <div class="minimal-legal d-flex gap-4">
          <a href="version" class="legal-link-minimal">{{version}}</a>
          <a [href]="pdpaUrl" target="_blank" class="legal-link-minimal" *ngIf="pdpaUrl">{{'Privacy Policy' |
            translate}}</a>
        </div>
      </div>
    </div>
  </div>
</footer>